import { OrderStatus } from "@/enums/order";
import { api } from "@/services/api";
import {
  AttributionOptions,
  OrderFilters,
  OrderWithRelations,
  PaginatedResponse,
} from "@/types";
import { OrderDetailResponse } from "@/types/order-detail.interface";

export const codPaymentUrl = (orderId: string): string =>
  api.getUri({ url: `/v1/payment/cod/${orderId}` });

export class OrderRepository {
  async findAll(
    filters: OrderFilters = {},
  ): Promise<PaginatedResponse<OrderWithRelations>> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((val) => params.append(key, val));
        } else {
          params.append(key, value.toString());
        }
      }
    });

    const response = await api.get(`/v1/admin/orders?${params.toString()}`);

    return response.data;
  }

  async attributionOptions(): Promise<AttributionOptions> {
    const response = await api.get("/v1/admin/orders/attribution-options");

    return response.data;
  }

  async findById(id: string): Promise<OrderDetailResponse> {
    const response = await api.get(`/v1/admin/orders/${id}`);

    return response.data;
  }

  async cancelOrder(orderId: string): Promise<OrderWithRelations> {
    const response = await api.patch(
      `/v1/admin/orders/${orderId}/update-status`,
      {
        status: OrderStatus.CANCELLED,
      },
    );

    return response.data;
  }

  async deleteOrder(orderId: string): Promise<void> {
    await api.delete(`/v1/admin/orders/${orderId}`);
  }

  async rescheduleDelivery(
    orderId: string,
    deliveryDate: string,
  ): Promise<OrderWithRelations> {
    const response = await api.patch(
      `/v1/admin/orders/${orderId}/delivery-date`,
      { deliveryDate },
    );

    return response.data;
  }

  async refundOrder(
    orderId: string,
    amount: number,
    reason?: string,
  ): Promise<OrderWithRelations> {
    const response = await api.post(`/v1/admin/orders/${orderId}/refund`, {
      amount: amount,
      reason: reason,
    });

    return response.data;
  }
}
